import React, { Component } from 'react'
import styled from 'styled-components'
import {
  withStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Paper
} from '@material-ui/core'

// const styles = theme => ({
//
// })

const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  }
}))

class LostOppTable extends Component {
  constructor(props) {
    super(props)
  }

  render() {

    return(
      <div>
        <Typography></Typography>
        <Paper style={{border: "1px solid #25aae1", borderRadius: "10px"}}>
          <Table size="small" style={{borderRadius: "10px"}}>
            <TableHead>
              <TableRow style={{height: 50, backgroundColor: '#007ac9'}}>
                <TableCell style={{width: 50, borderTopLeftRadius: "10px"}} align="center"><Typography style={{color: '#fff', fontWeight: 'bold'}} variant="caption">Decile</Typography></TableCell>
                <TableCell style={{width:250, borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography style={{color: '#fff', fontWeight: 'bold'}} variant="caption">Average Lost Opportunity Counts (By Month)</Typography></TableCell>
                <TableCell style={{width:250, borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography style={{color: '#fff', fontWeight: 'bold'}} variant="caption">Average Incremental Sales(By Month)</Typography></TableCell>
                <TableCell style={{width:250, borderTopRightRadius: "10px", borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography style={{color: '#fff', fontWeight: 'bold'}} variant="caption">Incremental Return On Ad Spend</Typography></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {this.props.data.map((row, i) => (
                <StyledTableRow 
                  key={row.decID} 
                  // style={i%2 === 0 ? {backgroundColor: "#5e5e5e"} : {backgroundColor: "#707070"}}
                  style={{backgroundColor: `${this.props.dark ? "#6e6e6e" : "#fff"}`}}
                >
                  <TableCell align="center"><Typography variant="caption" style={{color: `${this.props.dark ? "#fff" : "#6e6e6e"}`}}>{row.decID}</Typography></TableCell>
                  <TableCell style={{borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography variant="caption" style={{color: `${this.props.dark ? "#fff" : "#6e6e6e"}`}}>{Math.round(row.lostOpp.reduce((a,b) => a + b, 0)/ this.props.dataCount).toLocaleString('en')}</Typography></TableCell>
                  <TableCell style={{borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography variant="caption" style={{color: `${this.props.dark ? "#fff" : "#6e6e6e"}`}}>{'$' + Math.round(row.cpp * (row.lostOpp.reduce((a,b) => a + b, 0)/ this.props.dataCount) * row.roi).toLocaleString('en')}</Typography></TableCell>
                  <TableCell style={{borderLeft:  '1px solid #dcdbdc'}} align="right"><Typography variant="caption" style={{color: `${this.props.dark ? "#fff" : "#6e6e6e"}`}}>{Math.round(row.roi * 100) + '%'}</Typography></TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    )
  }
}

export default LostOppTable
